export const initCookiebot = () => {
    const cookieTrigger = document.querySelector<HTMLButtonElement>(
        '[data-selector="cookie-trigger"]',
    );

    if (!cookieTrigger) return;
    
    cookieTrigger.addEventListener("click", () => {
        if (typeof Cookiebot !== "undefined" && Cookiebot.renew) {
            Cookiebot.renew();
        } else {
            console.warn("Cookiebot not available yet");
        }
    });
};
